module.exports = __webpack_public_path__ + "mp.f077d4cd084b20588f06.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/mp.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/mp.svg
// module chunks = styles